module.exports = __webpack_public_path__ + "static/hero2.93fa3742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pc/hero2.jpg
// module id = 506
// module chunks = 35783957827783